// src/pages/GettingStarted.js
import React from 'react';

function GettingStarted() {
  return (
    <div>
      <h2>Getting Started</h2>
      <p>This is the getting started page. Here you can find the initial setup information.</p>
    </div>
  );
}

export default GettingStarted;
